var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.55 274.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:white;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Black_logomark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M124.25,109c-3.73,0-6.86-.17-10,0-5.09.36-10.29.45-15.23,1.57A53.5,53.5,0,0,0,57.24,159.1c-1.19,17.81-1.48,35.71-1.54,53.57-.06,15.93,7.12,28.46,20.6,36.93,3.38,2.12,3.55,1.62,5.64,1.61,14-.05,28,0,42,0a40.65,40.65,0,0,0,13.61-2.24,39.8,39.8,0,0,0,26.61-37.21c.13-18.62,0-58.51,0-60.18h79.6l13.27-39.86c-2.08,0-51.5.08-74.74-.08-3.69,0-6.37,1-8.78,3.72-2.66,3.06-5.7,5.78-8.77,8.85-.87-4.29-.76-55.84.09-58.85h85.52c4.41-13.22,9-26.39,13.18-39.8a26.68,26.68,0,0,0-2.78-.08q-33.91,0-67.86,0a7.6,7.6,0,0,0-4.76,1.78q-30.71,23.08-61.48,46.08a5.51,5.51,0,0,0-2.47,5C124.31,87,124.25,109,124.25,109ZM111.31,224c-4-.17-8-.07-12-.3-6.8-.41-10.07-5.28-10.24-11.51.19-5.37.33-37.72.55-48.2a22.39,22.39,0,0,1,14.46-20.83,11.44,11.44,0,0,1,3.61-.92c5.48-.1,11,0,16.93,0,0,3.4-.15,46.34-.14,64.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmDark);
export default __webpack_public_path__ + "static/media/logo-sm-dark.4041b20c1e6e0bbafb4e0b273836b334.svg";
export { ForwardRef as ReactComponent };